import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";

export type ExecutionLogFiltersMessages = FiltersMessages & {
  // Filter Options
  allOption: string;
  logContactOption: string;
  statusOption: string;
  logDateOption: string;

  // Status Options
  sentOption: string;
  failedOption: string;
};

export const EXECUTION_LOG_FILTER_MESSAGES: ExecutionLogFiltersMessages = {
  ...FILTER_MESSAGES,

  // Filter Options
  allOption: "Todos",
  logContactOption: "Contato",
  statusOption: "Status",
  logDateOption: "Data do Log",

  // Status Options
  sentOption: "Enviado",
  failedOption: "Falhou",
};
